import { Container } from '@hover/blueprint';
import React from 'react';
import ProductionMobile from './ProductionMobile';
import ProductionDesktop from './ProductionDesktop';
import {
  DIRECT_ORDERING_LIST_ITEMS,
  LABOR_MANAGEMENT_LIST_ITEMS,
} from '../../../constants';

const Production = () => (
  <Container maxW="1200px" px={500} pb={{ base: 0, desktop: 1100 }}>
    <ProductionMobile
      orderDirectlyListItems={LABOR_MANAGEMENT_LIST_ITEMS}
      realTimeListItems={DIRECT_ORDERING_LIST_ITEMS}
    />
    <ProductionDesktop
      orderDirectlyListItems={LABOR_MANAGEMENT_LIST_ITEMS}
      realTimeListItems={DIRECT_ORDERING_LIST_ITEMS}
    />
  </Container>
);

export default Production;
